module.exports = "https://static.wmbcdn.com/uniweb/images/4e44ff15fde1fb9af297dda027422e0d.svg";